<template>
  <v-card tile>
    <v-card-title>
      Vozila
      <v-spacer></v-spacer>
      <v-btn
          icon
          large
          @click="downloadExcel"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="vehicles">
      <v-data-table
          :headers="headers"
          :items="vehicles.data"
          :page="tableOptions.page"
          :items-per-page="tableOptions.itemsPerPage"
          :server-items-length="vehicles.total"
          @update:options="tableOptions = $event"
          :search="search"
          :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
          sort-by="id"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
                v-model="search"
                @change="updateFilters"
                append-icon="mdi-magnify"
                label="Iskalnik"
                single-line
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="create"
            >Dodaj
            </v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
              tooltip="Uredi"
              icon="mdi-pencil"
              @click="$router.push({ name: 'Vehicle', params: { id: item.id } })"
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Dokumenti"
              icon="mdi-file-document"
              @click="
              $router.push({
                name: 'VehicleDocuments',
                params: { vehicleId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Aktivnost"
              icon="mdi-archive"
              @click="
              $router.push({
                name: 'VehicleActivity',
                params: { vehicleId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Izbriši"
              icon="mdi-delete"
              @click="remove(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadVehicles">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import TooltipIconButton from "@/components/TooltipIconButton.vue";

export default {
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      {text: "Proizvajalec", value: "manufacturer"},
      {text: "Model", value: "model"},
      {text: "Registrska tablica", value: "registration_plate"},
      {text: "", value: "actions", sortable: false},
    ],
    vehicles: null,
    editedIndex: -1,
    editedItem: {},
    search: ""
  }),
  mounted() {
    this.search = this.$route.query.search || "";
  },
  methods: {
    loadVehicles() {
      let orderBy = {};
      if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
      ) {
        orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
      }
      let params = {
        page: this.tableOptions.page,
        perPage: this.tableOptions.itemsPerPage,
        orderBy,
      };
      if (this.$route.query.search) {
        params["filters"] = {
          registration_plate: encodeURI("%" + this.$route.query.search + "%"),
        };
      }

      this.$http.get("api/v1/vehicles", {params}).then((response) => {
        this.vehicles = response.data;
      });
    },
    create() {
      this.$swal({
        title: "Dodaj vozilo",
        text: "Vpišite registersko tablico vozila",
        confirmButtonText: "Dodaj",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
        input: "text",
      }).then((value) => {
        if (!value.value) {
          return;
        }
        this.$http
            .post("api/v1/vehicles", {registration_plate: value.value})
            .then((response) => {
              this.$router.push({
                name: "Vehicle",
                params: {id: response.data.id},
              });
            });
      });
    },
    remove(item) {
      this.$swal({
        title: "Pozor",
        text:
            "Ali ste prepričani da želite izbrisati vozilo " +
            item.registration_plate,
        type: "warning",
        confirmButtonText: "Izbriši",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
      }).then((value) => {
        if (value.value !== true) {
          return;
        }
        this.$http.delete("api/v1/vehicles/" + item.id).then(() => {
          this.loadVehicles();
        });
      });
    },
    updateFilters() {
      let query = {...this.$route.query};
      query['page'] = 1;
      delete query['search'];
      if (this.search.length > 0) {
        query['search'] = this.search;
      }
      this.$router.replace({
        query,
      }).catch(() => {
      });
      this.loadVehicles();
    },
    downloadExcel() {
      this.$http({
        url: 'api/v1/vehicles/export',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data])
      );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
            "download",
            "vehicles.xlsx"
        );
        document.body.appendChild(link);
        link.click();

      });
    }
  },
  computed: {
    tableOptions: {
      get() {
        return {
          page: parseInt(this.$route.query.page) || 1,
          itemsPerPage: parseInt(this.$route.query.perPage) || 10,
          sortBy: this.$route.query.sortBy ? [this.$route.query.sortBy] : [],
          sortDesc: [this.$route.query.sortDesc === 'true'],
        }
      },
      set(value) {
        let query = {
          page: value.page,
          perPage: value.itemsPerPage,
        };
        if (this.$route.query.search) {
          query["search"] = this.$route.query.search;
        }
        if (value.sortBy.length > 0) {
          query.sortBy = value.sortBy[0];
          query.sortDesc = value.sortDesc[0];
        }
        this.$router.replace({
          query,
        }).catch(() => {
        });
      },
    },
  },
  watch: {
    tableOptions: {
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          return;
        }
        this.loadVehicles();
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    TooltipIconButton,
  },
};
</script>
<style></style>
